import { moment } from '../main';
import store from '../store';

export default {
    handleErrors(status, errorList, errorMutation) {
        if (status === -1) {
            errorList = [
                {
                    property: 'global',
                    message: 'MESSAGE.GENERAL.NO_SERVER_CONNECTION'
                }
            ];
        } else if (status === 500) {
            errorList = [
                {
                    property: 'global',
                    message: 'MESSAGE.GENERAL.SERVER_ERROR_OCCURRED'
                }
            ];
        } else if (status !== 400) {
            errorList = [
                {
                    property: 'global',
                    message: 'MESSAGE.GENERAL.ERROR_OCCURRED'
                }
            ];
        }

        const errors = {};
        for (let i = 0; i < errorList.length; i++) {
            const error = errorList[i];
            const lowerCase = error.property.charAt(0).toLowerCase() + error.property.slice(1);
            if (!errors[lowerCase]) {
                errors[lowerCase] = [];
            }
            let message = store.getters['translation/translate'](error.message);

            if (error.additionalData) {
                for (let propertyName in error.additionalData) {
                    if (error.additionalData.hasOwnProperty(propertyName)) {
                        message = message.replace(new RegExp(`\{\{${propertyName}\}\}`, 'g'),
                            error.additionalData[propertyName]);
                    }
                }
            }

            errors[lowerCase].push(message);
            store.dispatch('settings/addError',
                message,
                { root: true });
        }

        if (errorMutation) {
            store.commit(errorMutation,
                errors,
                { root: true });
        }
    },
    convertStringToDate(store, dateString, toUtc, format) {
        if (!format) {
            format = 'L LT';
        }
        if (dateString && dateString.length > 0) {
            var zoned = moment.tz(dateString, format, store.rootState.settings.account.timezone);
            if (zoned.isValid()) {
                if (toUtc) {
                    return moment.tz(zoned, 'Etc/UTC');
                } else {
                    return zoned;
                }
            }
        }
        return null;
    },
    disableButton: function(btn) {
        if (btn && btn.className) {
            btn.className += ' disabled';
        }
    },
    enableButton: function(btn) {
        if (btn && btn.className && btn.className.indexOf("disabled") > 0) {
            btn.className = btn.className.replace(new RegExp('(?:^|\\s)' + 'disabled' + '(?:\\s|$)'), ' ');
        }
    },
    scrollToTop: function() {
        window.scrollTo(0, 0);
    }
};



// WEBPACK FOOTER //
// ./src/utils/utilities.js